import { Earth } from './Earth';
import Phaser from 'phaser';

export class CrystalEarth extends Earth {
  protected override getAtmosphereColor(): number {
    throw new Error('Method not implemented.');
  }
  protected override getEnergyColor(): number {
    throw new Error('Method not implemented.');
  }
  protected override getParticleColor(): number {
    throw new Error('Method not implemented.');
  }
  protected override getShieldColor(): number {
    throw new Error('Method not implemented.');
  }
  protected override getCoreColor(): number {
    throw new Error('Method not implemented.');
  }
  constructor(scene: Phaser.Scene, x: number, y: number) {
    // Call parent constructor with proper parameters
    super(scene, x, y, 600, 0.25, 4, 15000, 0);
    
    // Set specific properties
    this.damageResistance = 0.25;
    this.specialAbility = 'GenerateEnergy';
    this.abilityCooldown = 15000;
  }

  override useSpecialAbility(): void {
    this.generateEnergy();
  }

  override activateAbility(): void {
    this.playAbilityEffect();
    this.generateEnergy();
  }

  private generateEnergy(): void {
    // Generate energy credits instantly
    if ((this.scene as any).addEnergyCredits) {
      (this.scene as any).addEnergyCredits(300);
    } else if ((this.scene as any).energyCredits !== undefined) {
      (this.scene as any).energyCredits += 300;
      if ((this.scene as any).creditsText) {
        (this.scene as any).creditsText.setText(`Credits: ${(this.scene as any).energyCredits}`);
      }
    }
  }

  override upgrade(): void {
    this.level++;
    this.baseMaxHealth += 100;
    this.baseDefense += 0.03;
    this.damageResistance += 0.03;
    this.recalculateStats();
    this.health = this.effectiveMaxHealth;
  }
} 